<deprecated-labeled-field [label]="label" [help]="help" [required]="required">
  <enhanced-select-deprecated
    #selectElement
    [placeholder]="placeholder"
    [required]="required"
    [disabled]="disabled || loading"
    (valueChange)="valueChange.emit($event)"
    [(value)]="value"
    [autoFocus]="autoFocus"
  >
    <option *ngIf="loading" [value]="value">Loading...</option>
    <ng-content></ng-content>
  </enhanced-select-deprecated>
</deprecated-labeled-field>
